import { render, staticRenderFns } from "./QRBadgeDownload.vue?vue&type=template&id=0cbf3a3e&scoped=true"
import script from "./QRBadgeDownload.vue?vue&type=script&lang=js"
export * from "./QRBadgeDownload.vue?vue&type=script&lang=js"
import style0 from "./QRBadgeDownload.vue?vue&type=style&index=0&id=0cbf3a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf3a3e",
  null
  
)

export default component.exports